// extracted by mini-css-extract-plugin
export default {"SearchFieldContainer":"MobileSearchField_SearchFieldContainer__b-YY+"};